module.exports = __webpack_public_path__ + "static/media/IR.7fdefb27.png";